import React from "react";
import "./styles.scss";

// Confirmation step before the cart is sent as an order, so a stray click
// on "Send order" cannot submit the purchase immediately.
export const OrderConfirmationModal = ({
  isOpen,
  itemCount,
  total,
  isSending,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="order-confirmation-modal-overlay">
      <div className="order-confirmation-modal">
        <div className="modal-header">
          <h4 className="modal-title">Send order?</h4>
        </div>
        <div className="modal-body">
          <p>
            You are about to send an order for{" "}
            <strong>
              {itemCount} {itemCount === 1 ? "item" : "items"}, {total} kudos
              total
            </strong>
            .
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-default"
            onClick={onCancel}
            disabled={isSending}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onConfirm}
            disabled={isSending}
          >
            {isSending ? "Sending..." : "Send order"}
          </button>
        </div>
      </div>
    </div>
  );
};
